import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { cuentaBancaria } from "../models/cuenta-bancaria.model";
import { ListaSoportesReembolsos } from "../models/lista-soportes_de-reembolsos.model";
import { Lista } from "../models/lista.model";
import { RequestFileLoad } from "../models/request-file-load.model";
import { RefundRequest } from "../models/request-refund.model";
import { ApiConfig } from "./config/api.config";

@Injectable()
export class RefundService{
    constructor(
        private http: HttpClient,
        private api: ApiConfig,     
    ){}

    getReembolsos(user : string, contract : string): Observable<Array<RefundRequest>>{
        return this.http.get<Array<RefundRequest>>(this.api.url + '/refunds/' + user + '/' + contract);
    }

    getValidaExistente(user : string, contract : string) : Observable <boolean> {
        return this.http.get<boolean>(this.api.url + '/refunds/_public/' + user + '/' + contract);
    }

    uploadFile(contract: string
        , userDocument: string
        , idRefundRequest: string
        , refundTypeName: string
        , supportFileType: string
        , file: RequestFileLoad) : Observable <any> {
        return this.http.post<any>(this.api.url + '/refunds/uploadFile', {contract, userDocument, idRefundRequest, refundTypeName, supportFileType, file});
    }

    getTiposReembolsos() : Observable<Array<Lista>> {
        return this.http.get<Array<Lista>>(this.api.url + '/refunds/tipos');
    }

    getListaSoportesDeReembolsos() : Observable<Array<ListaSoportesReembolsos>> {
        return this.http.get<Array<ListaSoportesReembolsos>>(this.api.url + '/refunds/soportes');
    }

    saveRequestRefund(obj : RefundRequest) : Observable<any>{
        return this.http.post<any>(this.api.url + '/refunds/save', obj);
    }

    getUltimasCuentasBancarias(contrato: string, numeroRegistros: number): Observable<Array<cuentaBancaria>> {
        return this.http.get<Array<cuentaBancaria>>(this.api.url + '/refunds/cuentasBancarias/' + contrato + "/" + numeroRegistros);
    }
}


// WEBPACK FOOTER //
// /app/src/app/shared/services/refund.service.ts